// sessionInit.js
import axios from 'axios';
import { DEV_BASE_URL, SOURCE } from './constants';

export async function initializeSession() {
  try {
    // Check if already initialized (optional but useful for dev)
    if (localStorage.getItem('authToken')) return;

    const res = await axios.get(`${DEV_BASE_URL}get_session/?source=${SOURCE}`);
    const token = res.data.data.access_token['token'];
    const userId = res.data.data['user_id'];
    const session_key = res.data.data['session_key'];

    localStorage.setItem('authToken', token);
    localStorage.setItem('userId', userId);
    localStorage.setItem('session_key', session_key);

    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    axios.defaults.headers.common['session_key'] = session_key;
  } catch (error) {
    console.error('Failed to initialize session:', error);
  }
}
